import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';

import { stateCurrentName } from '@Selectors/StateCurrentSelectors';
import { reducer } from './HeaderComponentReducer';
import { companyLogoUrl } from './HeaderComponentSelectors';
import { key } from './HeaderComponentConstants';
import HeaderComponent from './HeaderComponent';

import { goToRouterState, getRouterHref } from './HeaderComponentActions';

const mapActionsToProps = {
  goToRouterState,
  getRouterHref,
};

function mapStateToProps(state) {
  return {
    stateCurrentName: stateCurrentName(state),
    companyLogoUrl: companyLogoUrl(state),
  };
}

export default compose(withReducer(key, reducer, true), connect(mapStateToProps, mapActionsToProps))(HeaderComponent);
